const WORKSPACE_BASE_ROUTE = '/user/workspaces';

export const WORKSPACE_API_ROUTES = {
  baseRoute: () => WORKSPACE_BASE_ROUTE,
} as const;
